import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];
  static values = {
    exportUrl: { type: String, default: "" },
  };

  initialize() {
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.hasModalTarget) return;
    this.modalTarget.style.display = "flex";
    document.addEventListener("keydown", this.handleKeydown);
  }

  close() {
    if (!this.hasModalTarget) return;
    this.modalTarget.style.display = "none";
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close();
  }

  submitCurrent() {
    this.submitExport(false);
  }

  submitAll() {
    this.submitExport(true);
  }

  submitExport(includeOldTeachingPoints) {
    this.close();

    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.exportUrlValue;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    if (csrfToken) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    const includeOldInput = document.createElement("input");
    includeOldInput.type = "hidden";
    includeOldInput.name = "include_old_teaching_points";
    includeOldInput.value = includeOldTeachingPoints ? "1" : "0";
    form.appendChild(includeOldInput);

    document.body.appendChild(form);
    form.submit();
  }
}
